import { useMembershipClaimsSync } from '../../hooks/useMembershipClaimsSync';

/** Tops up entitlement claims on a stale session token. Renders nothing. */
export default function MembershipClaimsBootstrap() {
  useMembershipClaimsSync();
  return null;
}
